/// <amd-module name="Artifacts/Upack/commands/Delete" />
import { getDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";
import { UpackActions } from "Artifacts/Upack/redux/Index";

export const createDeleteCommand = getDeleteCommandCreator(UpackActions.softDelete);
